
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface PlaylistDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  playlistName: string;
  onPlaylistNameChange: (name: string) => void;
  onCreatePlaylist: () => void;
}

const PlaylistDialog = ({ 
  isOpen, 
  onOpenChange, 
  playlistName, 
  onPlaylistNameChange, 
  onCreatePlaylist 
}: PlaylistDialogProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!playlistName.trim()) return;
    
    setIsSubmitting(true);
    try {
      await onCreatePlaylist();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => {
      if (!isSubmitting) {
        onOpenChange(open);
      }
    }}>
      <DialogContent className="sm:max-w-md">
        <form onSubmit={handleSubmit}>
          <DialogHeader>
            <DialogTitle>Créer une nouvelle playlist</DialogTitle>
            <DialogDescription>
              Donnez un nom à votre nouvelle playlist
            </DialogDescription>
          </DialogHeader>
          <div className="py-4">
            <Label htmlFor="playlist-name">Nom de la playlist</Label>
            <Input 
              id="playlist-name" 
              value={playlistName} 
              onChange={(e) => onPlaylistNameChange(e.target.value)}
              placeholder="Ma playlist"
              className="mt-2"
              autoFocus
              disabled={isSubmitting}
            />
          </div>
          <DialogFooter>
            <Button 
              variant="outline" 
              type="button" 
              onClick={() => onOpenChange(false)}
              disabled={isSubmitting}
            >
              Annuler
            </Button>
            <Button 
              type="submit"
              disabled={isSubmitting || !playlistName.trim()}
            >
              {isSubmitting ? (
                <>
                  <span className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></span>
                  Création...
                </>
              ) : 'Créer'}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default PlaylistDialog;
